import React, { FC, useEffect } from "react";
import Modal from "react-modal";
import { Booking } from "../Booking/Booking";
import { ErrorBoundary } from "../ErrorBoundary/ErrorBoundary";
import { useLabels } from "../Hooks/useLabels";
import { ModalThemeColor } from "../../../../Model/ModalThemeColor.csharp";
import classNames from "classnames";
import { ErrorMessage } from "../ErrorMessage/ErrorMessage";
import { CloseButton } from "../CloseButton/CloseButton";
import {QuickAppointmentSetupDto} from "../../BookingButton/QuickAppointmentSetupDto.csharp";

export type BookingModalProps = {
	isOpen: boolean;
	closeModal: () => void;
	disableBooking: boolean;
	modalThemeColor: ModalThemeColor;
	showCloseButton?: boolean;
	autostartBooking: boolean;
	ignorePersistedData?: boolean;
	quickAppointmentSetup?: QuickAppointmentSetupDto;
	breadcrumbs: string[];
};

export const BookingModal: FC<BookingModalProps> = ({
	isOpen,
	closeModal,
	disableBooking,
	modalThemeColor,
	showCloseButton,
	autostartBooking,
	ignorePersistedData,
	quickAppointmentSetup,
	breadcrumbs,
}) => {
	useEffect(() => {
		Modal.setAppElement("body");
	}, []);

	const { bookingLabels } = useLabels();
	const isVolvat = modalThemeColor == ModalThemeColor.Volvat;
	const isNimi = modalThemeColor == ModalThemeColor.Nimi;

	const errorLabel =
		bookingLabels?.commonLabels.globalBookingError ||
		"Sorry, something goes wrong. Please try again later.";

	return (
		<Modal
			isOpen={isOpen}
			className={classNames("BookingModal", {
				"BookingModal--volvat": isVolvat,
				"BookingModal--nimi": isNimi,
			})}
            ariaHideApp={false}
			overlayClassName="BookingModalOverlay"
			bodyOpenClassName="BookingModalBody--open"
		>
			{isOpen && (
				<div className="BookingModal__container">
					{disableBooking ? (
						<>
							<CloseButton onClick={closeModal} />
							<ErrorMessage
								className="BookingModal__errorMessage"
								message={errorLabel}
							/>
						</>
					) : (
						<ErrorBoundary
							className="BookingModal__errorMessage"
							message={errorLabel}
							closeModal={closeModal}
						>
							<Booking
								showCloseButton={showCloseButton}
								closeModal={closeModal}
								autostartBooking={autostartBooking}
								breadcrumbs={breadcrumbs}
								ignorePersistedData={ignorePersistedData}
								quickAppointmentSetup={quickAppointmentSetup}
								modalThemeColor={modalThemeColor}
							/>
						</ErrorBoundary>
					)}
				</div>
			)}
		</Modal>
	);
};
